import React from 'react';
import { Stack } from '../../../atoms/stack/Stack';
import { Typography } from '../../../atoms/typography/Typography';
import { cnMerge } from '../../../../utils/utils';

const GradientTextItem = ({ text, description, subDescription, textClass }) => (
  <Stack className="my-10 items-center">
    <Typography
      fontVariant="h1"
      className={cnMerge(
        textClass,
        'w-fit leading-none bg-gradient-to-r from-[#00C9BB] to-[#0098CB] !text-transparent bg-clip-text'
      )}
    >
      {text}
    </Typography>
    <Typography fontVariant="lg" className="w-fit max-w-60 font-normal">
      {description}
    </Typography>
    {subDescription && (
      <Typography
        fontVariant="md"
        className="!text-customGray-500 w-fit max-w-60 font-normal"
      >
        {subDescription}
      </Typography>
    )}
  </Stack>
);

export default GradientTextItem;
